/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { HttpErrorResponse } from '@angular/common/http';

export type ErrorMessageFindFn = (error: HttpErrorResponse) => string;

export const defaultFindFn = (error: HttpErrorResponse) => error?.error?.message;
